import DOMPurify from 'dompurify';
import {
    isLengthConditionFulfilled,
    isLowerCaseConditionFulfilled,
    isNumberConditionFulfilled,
    isSpecialCharacterConditionFulfilled,
    isUpperCaseConditionFulfilled,
} from 'susy-common/stringUtils';

export enum ExtensionRequestState {
    Sent = 'Sent',
    Received = 'Received',
    Accepted = 'Accepted',
    Declined = 'Declined',
}

export enum ExtensionRequestFileOfProofType {
    SickNote = 'Sick note',
    AcademicReason = 'Academic reason',
}

export enum ProjectStatus {
    approved = 'Approved',
    declined = 'Declined',
    registered = 'Registered',
    handedIn = 'Handed-In',
    evaluated = 'Evaluated',
    withdrawn = 'Withdrawn',
    saved = 'Saved',
    pending = 'Pending',
    failed = 'Failed',
    not_initialized = '',
}

export enum DeadlineStatus {
    registration = 'Registration',
    grading = 'Grading',
    submission = 'Submission',
    archiving = 'Archiving',
}

export enum ProjectEditableDatesEnum {
    registered = 'registered',
    handedIn = 'handedIn',
    evaluated = 'evaluated',
    submission = 'submission',
    evaluation = 'evaluation',
}

export enum ProjectSecondSupervisorStatus {
    accepted = 'Accepted',
    declined = 'Declined',
    pending = 'Pending',
}

export const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

export const sanitizeAndRemoveHTML = (str: string) => {
    const HTMLRegex = /(<([^>]+)>)/gi;
    return DOMPurify.sanitize(str, {})
        .replaceAll(HTMLRegex, '')
        .replaceAll('\n', '');
};

export const getPasswordStrength = (password: string) => {
    let passwordStrength = 0;
    if (isLengthConditionFulfilled(password)) {
        passwordStrength++;
    }
    if (isNumberConditionFulfilled(password)) {
        passwordStrength++;
    }
    if (isSpecialCharacterConditionFulfilled(password)) {
        passwordStrength++;
    }
    if (isLowerCaseConditionFulfilled(password)) {
        passwordStrength++;
    }
    if (isUpperCaseConditionFulfilled(password)) {
        passwordStrength++;
    }

    return passwordStrength;
};

export enum InvitationStatus {
    pending = 'pending',
    accepted = 'accepted',
    declined = 'declined',
    withdrawn = 'withdrawn',
}

export enum UserRoles {
    user = 'User',
    supervisor = 'Supervisor',
    admin = 'Admin',
    unauthenticated = 'Unauthenticated',
}

export const stringToUserRolesEnum = (role: string): UserRoles => {
    switch (role) {
        case 'User':
            return UserRoles.user;
        case 'Supervisor':
            return UserRoles.supervisor;
        case 'Admin':
            return UserRoles.admin;
        default:
            return UserRoles.unauthenticated;
    }
};

export enum PropertiesToKeep {
    intakes = 'intakes',
    supervisorGroups = 'supervisorGroups',
    programs = 'programs',
    faculties = 'faculties',
    departments = 'departments',
}

export const removePropertiesFromRole = (
    object: any,
    propertiesToKeep: PropertiesToKeep[]
) => {
    const allProperties = [
        'intakes',
        'supervisorGroups',
        'programs',
        'faculties',
        'departments',
    ];
    for (let index = 0; index < allProperties.length; index++) {
        if (
            object[allProperties[index]] &&
            !propertiesToKeep.some((prop) => prop === allProperties[index])
        ) {
            delete object[allProperties[index]];
        }
    }

    return object;
};

export enum ProjectUserChangesStatusEnum {
    accepted = 'Accepted',
    declined = 'Declined',
    pending = 'Pending',
}

export enum ProjectRegistrationAdminApprovalOutcomeEnum {
    APPROVED = 'APPROVED',
    DECLINED = 'DECLINED',
    PENDING = 'PENDING',
}

export enum ProjectRegistrationAdminDeclineReasons {
    NO_MEET_STANDARD = 'nomeetstandard',
    OTHER = 'other',
}

export enum ProjectSetAsFailedReasons {
    PLAGIARISM_CHECK = 'plagiarismcheck',
    STUDENTS_WITHDRAWAL = 'studentswithdrawal',
    OTHER = 'other',
}

export enum TimelineState {
    Future = 'Future',
    Ongoing = 'Ongoing',
    Archived = 'Archived',
}

export enum RubricStatus {
    NotInUse = 'NotInUse',
    Ongoing = 'Ongoing',
    Published = 'Published',
    Draft = 'Draft',
}
